import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "../api/baseApi.js";
import cartReducer from "../features/cart/slices/cartSlice.js";
import checkoutReducer from "../features/checkout/slices/checkoutSlice.js";
import { contentApi } from "../features/content/api/contentApi.js";
import offerReducer from "../features/offer/slices/offerSlice.js";
import wishlistReducer from "../features/wishlist/slices/wishlistSlice.js";

export const store = configureStore({
  reducer: {
    offer: offerReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    checkout: checkoutReducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [contentApi.reducerPath]: contentApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, contentApi.middleware),
  devTools: process.env.NODE_ENV !== "production",
});

export const RootState = store.getState;
export const AppDispatch = store.dispatch;

export default store;
